export class WPBlockVideoHandler {
	constructor() {
		this.selector = '.wp-block-video video';
		this.videoPlayers = document.querySelectorAll(this.selector);
		this.removeControls();
		this.videoStatesListeners(this.videoPlayers);
		window.addEventListener('click', this.activateControls.bind(this))
	}
	removeControls() {
		this.videoPlayers.forEach(el => {
			let hasCover = el.hasAttribute('poster');
			let hasControls = el.hasAttribute('controls');
			el.dataset.state = 'idle';
			hasControls && el.setAttribute('data-controls', true);
			hasCover && el.setAttribute('data-cover',true);
			hasCover && el.removeAttribute('controls');

			if ( !el.closest('.wp-block-video__holder') ) {
				let holder = document.createElement('div');
				let cover = document.createElement('div');
				holder.classList.add('wp-block-video__holder');
				cover.classList.add('wp-block-video__cover');
				el.insertAdjacentElement('afterend', holder);
				holder.insertAdjacentElement('beforeend', cover);
				cover.appendChild(el);
				hasCover && cover.insertAdjacentHTML('beforeend', '<i></i>');
			}
		})
	}
	activateControls(e) {
		let target = e.target.closest(this.selector);
		if (!target || !target.hasAttribute('data-cover')) return;
		target.hasAttribute('data-controls') && target.setAttribute('controls', true);
		setTimeout(() => {
			target.play();
		}, 100);
	}
	videoStates(e) {
		e.type === 'play' && (e.target.dataset.state = 'playing')
		e.type === 'pause' && (e.target.dataset.state = 'paused')
		e.type === 'ended' && this.videoStop(e.target);
	}
	videoStop(video) {
		if (!video || video.hasAttribute('loop')) return;
		video.dataset.state = 'idle';
		video.removeAttribute('controls');
		const currentSrc = video.src;
		video.src = ''
		video.src = currentSrc
	}

	videoStatesListeners(nodes) {
		nodes && nodes.forEach(v => {
			v.removeEventListener('play', this.videoStates.bind(this));
			v.addEventListener('play', this.videoStates.bind(this));
			v.removeEventListener('pause', this.videoStates.bind(this));
			v.addEventListener('pause', this.videoStates.bind(this));
			v.removeEventListener('ended', this.videoStates.bind(this));
			v.addEventListener('ended', this.videoStates.bind(this));
		})
	}
}

export const wpBlockVideoHandler = new WPBlockVideoHandler();
